var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-gray-600 w-full md:w-auto"
  }, [_c('div', {
    staticClass: "cursor-pointer inline-block w-max",
    class: {
      'text-pink-600': _vm.mutableValue
    }
  }, [_c('icon', {
    staticClass: "comment-input",
    attrs: {
      "id": _vm.name,
      "name": "message-circle"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "clickOutside",
      rawName: "v-clickOutside",
      value: _vm.forceHide,
      expression: "forceHide"
    }],
    staticClass: "relative"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mutableValue,
      expression: "mutableValue"
    }, {
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "comment-text absolute z-20 top-0 right-0 w-full md:w-auto py-4 px-5 rounded-lg bg-white shadow-md shadow-gray-600 text-base focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50",
    class: {
      'cursor-not-allowed': _vm.disabled || _vm.disabled_pass
    },
    attrs: {
      "name": _vm.name,
      "rows": "9",
      "cols": "40",
      "placeholder": _vm.disabled || _vm.disabled_pass ? '' : 'Ecrivez votre commentaire',
      "disabled": _vm.disabled || _vm.disabled_pass
    },
    domProps: {
      "value": _vm.mutableValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.mutableValue = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute z-20 mb-4 right-0 inset-y-0 pt-6 pr-6 flex items-center cursor-pointer"
  }, [_c('SpeechToText', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    on: {
      "result": function (result) {
        return _vm.updateMutable(result);
      },
      "startRecognition": _vm.startRecognition,
      "stopRecognition": _vm.stopRecognition
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }